import { BasicObject } from '../uiObjects/basicObject';

import { MathObject } from './MathObject';

export function hasText(basicObject: BasicObject): boolean {
  if (basicObject.children?.length == 1)
    return hasText(basicObject.children[0]);

  return (basicObject as { t?: string }).t === 'text';
}

export function hasQuantity(mathObject: MathObject): boolean {
  if (!mathObject.children) return false;

  return mathObject
    .getValueChildren()
    .some(
      child =>
        child.t === 'quantity' ||
        child.t === 'absoluteValue' ||
        (child.t === 'm' && hasQuantity(child))
    );
}
